import { create } from 'zustand';

export type LandingProjectStatus = 'creating' | 'failed' | 'idle' | 'ready';

type LandingProjectState = {
  error: unknown;
  progress: number;
  projectId: null | string;
  spaceId: null | string;
  start: (spaceId: string) => void;
  status: LandingProjectStatus;
  reset: () => void;
  setFailed: (error: unknown) => void;
  setProgress: (progress: number) => void;
  setReady: (projectId: string) => void;
};

const INITIAL = {
  error: null,
  progress: 0,
  projectId: null,
  spaceId: null,
  status: 'idle' as LandingProjectStatus,
};

export const useLandingProjectStore = create<LandingProjectState>((set) => ({
  ...INITIAL,
  start: (spaceId) => set({ progress: 5, spaceId, status: 'creating' }),
  reset: () => set(INITIAL),
  setFailed: (error) => set({ error, status: 'failed' }),
  setProgress: (progress) => set({ progress }),
  setReady: (projectId) => set({ progress: 20, projectId, status: 'ready' }),
}));
